"use strict";

import {BootstrapButton, BootstrapModal} from './react-bootstrap'
import {postJSON} from './shim.js'
$.postJSON = postJSON;

import {ProductImage, PurchaseModal} from './components/categories'
import {LoginForm, LoginModal} from './components/login'
import {RegisterForm} from './components/register'
import {Cart} from './components/cart'
import {Checkout} from './components/checkout'
import {UserSettingsForm} from './components/UserSettings'
import {ChangePasswordForm} from './components/ChangePassword'
import {EditAddressForm} from './components/address'
import {Model} from './model'
import {confirmModal, alertModal, getParameterByName} from './utils'
import {PasswordResetBeginForm, PasswordResetConfirmForm} from './components/PasswordReset'

window.ProductImage = ProductImage;
window.PurchaseModal = PurchaseModal;
window.RegisterForm = RegisterForm;
window.LoginForm = LoginForm;
window.Cart = Cart;
window.Checkout = Checkout;
window.UserSettingsForm = UserSettingsForm;
window.ChangePasswordForm = ChangePasswordForm;
window.EditAddressForm = EditAddressForm;
window.getParameterByName = getParameterByName;
window.confirmModal = confirmModal;
window.alertModal = alertModal;
window.PasswordResetBeginForm = PasswordResetBeginForm;
window.PasswordResetConfirmForm = PasswordResetConfirmForm;

$(document).on('click', 'a.login', e => {
    e.preventDefault();
    showLoginModal(() => {
        location.reload();
    });
});


$(document).on('click', '#cart', e => {
    if (!window.store.get('user')) {
        e.preventDefault();
        showLoginModal(() => {
            window.location = '/cart';
        });
    }
});


function showLoginModal(callback) {
    var modalMountPoint = document.querySelector('#modal');

    ReactDOM.render(
        <LoginModal
            ref={c => c && c.openModal()}
            onHidden={()=> ReactDOM.unmountComponentAtNode(modalMountPoint)}
            onLoggedIn={user => {
                window.store.set('user', user);
                if (callback) callback();
            }}
        />,
        modalMountPoint
    );
}

window.showLoginModal = showLoginModal;

$(document).on('click', '#logout', e => {
    e.preventDefault();
    $.postJSON('/users/logout').done(() => window.location = '/users/logged_out')
});


function RightHeaderBar() {
    var user = window.store.get('user'),
        renderCart = window.store.get('renderCart'),
        cartQuantity = window.store.get('cartQuantity');

    var fragments = !user ?
        [
            <li key="login"><a className="login" href="/users/login"><span className="glyphicon glyphicon-log-in"></span> Log in</a></li>,
            <li key="register"><a className="register" href="/users/register"><span className="glyphicon glyphicon-th-list"></span> Register</a></li>
        ] :
        [
            <li key="user"><a href="/users/profile">{ user.name || user.email }</a></li>,
            <li key="logout"><a id="logout" href="/users/logout"><span className="glyphicon glyphicon-log-out"></span> Log out</a></li>,
        ];

    if (renderCart) fragments.push(
        <li key="cart">
            <a id="cart" href="/cart"><span className="glyphicon glyphicon-shopping-cart"></span> ({cartQuantity} items)</a>
        </li>);

        /*fragments.push(
        <li key="search">
            <form action="/search" className="form-inline">
                <div className="input-group">
                    <input type="text" className="form-control" name="name" style={{marginLeft: '4px', height: '30px', width: '9em'}} placeholder="产品编号或名称" />
                    <div className="input-group-btn">
                        <button className="btn btn-default btn-sm" type="submit">
                            <span className="glyphicon glyphicon-search"></span>
                        </button>
                    </div>
                </div>
            </form>
        </li>
    );*/

    return <ul className="nav navbar-nav navbar-right">
        { fragments }
    </ul>;
}


$(function() {
    window.store = Model(Object.assign({renderCart: true}, window.data));

    var renderRHB = function() {
        ReactDOM.render(<RightHeaderBar />, document.querySelector('.navbar-sm'))
    };
    window.store.on('cartQuantity user', renderRHB);
    renderRHB();
});
